<template>
    <div id="modal_component" class="modal-component" v-if="modal">
        <div class="modal-area">
            <div class="modal-overlay">
                <div class="modal-overlay-inside">
                    <div class="modal-outer">
                        <div class="modal-close" @click="reload ? reloadPage() : hideModal()"></div>
                        <div class="modal-inner">
                            <form @submit.prevent="validate">
                                <p class="p2">{{ message }}</p>
                                <div class="form-actions">
                                    <button class="button--action button--confirm"
                                            type="button"
                                            @click="reload ? reloadPage() : hideModal()">
                                        {{ button || 'OK' }}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        dependencies: ['popup'],
        computed: {
            message () {
                return Array.isArray(this.$store.getters.modals.alert.message) ? this.$store.getters.modals.alert.message.join(' ') : this.$store.getters.modals.alert.message
            },
            button () {
                return this.$store.getters.modals.alert.button;
            },
            modal () {
                return this.$store.getters.modals.alert.visible
            },
            reload () {
                return this.$store.getters.modals.alert.reload
            }
        },
        methods: {
            hideModal () {
                this.popup.hide();
            },
            reloadPage () {
                window.location.reload();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/layout/partials/section/modals/Alert.vue